<app-header>

</app-header>
<main class="timeapp documents" style="display: flex;  flex-direction: column; overflow: hidden;">
	<div class="searchbar">
		<mat-form-field [formGroup]="searchForm">
			<mat-label>{{ "MAIN_APP_TIME_PLUS.DOCUMENT_COMPONENT.label_search" | translate }}</mat-label>
			<input #searchInput formControlName="searchInput" matInput/>
		</mat-form-field>
		<button [matMenuTriggerFor]="filterMenu" mat-icon-button>
			<mat-icon>filter_list</mat-icon>
		</button>
	</div>
	<div class="document-list">
		<mat-list>
			@for (document of filteredDocuments$ | async; track document) {
				<mat-list-item>
					<div class="list-element">
						<img alt="image" src="/assets/obj_activity_icons/{{ document.icon }}" (click)="showDocument(document.documentID)"/>
						<div class="text-block" (click)="showDocument(document.documentID)">
							<div *ngIf="document.description" class="document-description">{{ document.description }}</div>
							<div *ngIf="(document.modifiedBy) && document.modified" class="document-info">
								<span>{{ document.modifiedBy }}</span>
								<span *ngIf="(document.modifiedBy) && document.modified"> | </span>
								<span>{{ document.modified }}</span>
							</div>
						</div>
						<button [matMenuTriggerFor]="documentActionMenu" mat-icon-button [matMenuTriggerData]="{documentID: document.documentID}">
							<mat-icon>more_vert</mat-icon>
						</button>
					</div>
				</mat-list-item>
			}
		</mat-list>
	
	</div>

</main>
<footer class="timeapp documents">
	<a routerLink="/timeapp" style="color: white;">
		<mat-icon class="">
			arrow_back
		</mat-icon>
	</a>
	<mat-icon (click)="uploader.click()" class="icon-size">upload_file</mat-icon>
	<input #uploader (change)="uploadDocument($event, uploader)" hidden multiple type="file"/>
</footer>


<mat-menu #filterMenu="matMenu">
	<button (click)="setSorting('date')" mat-menu-item>{{ "MAIN_APP_TIME_PLUS.DOCUMENT_COMPONENT.sort_option_date" | translate }}</button>
	<button (click)="setSorting('document')" mat-menu-item>{{ "MAIN_APP_TIME_PLUS.DOCUMENT_COMPONENT.sort_option_document" | translate }}</button>
	<button (click)="setSorting('name')" mat-menu-item>{{ "MAIN_APP_TIME_PLUS.DOCUMENT_COMPONENT.sort_option_name" | translate }}</button>
	<button (click)="setSorting('type')" mat-menu-item>{{ "MAIN_APP_TIME_PLUS.DOCUMENT_COMPONENT.sort_option_filetype" | translate }}</button>
</mat-menu>

<mat-menu #documentActionMenu="matMenu">
	<ng-template let-documentID="documentID" matMenuContent>
		<button (click)="downloadDocument(documentID)" mat-menu-item>Download</button>
		<button (click)="deleteDocument(documentID)" *ngIf="canDelete(documentID)" mat-menu-item>Löschen</button>
	</ng-template>
</mat-menu>